module.exports = __webpack_public_path__ + "static/media/renshibankuai2.a7a708a2.png";